import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Nav from "../components/Nav";
import { useAuth } from "../context/AuthContext";
import { LockKey } from "@phosphor-icons/react";

export default function AdminLogin() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    const res = await login(form.email, form.password);
    setLoading(false);
    if (res.ok) {
      if (res.user.role !== "super_admin") {
        setErr("Not a super admin account");
        return;
      }
      nav("/admin/dashboard");
    } else setErr(res.error);
  };

  return (
    <div>
      <Nav />
      <section className="border-b border-black bg-black text-white min-h-[70vh] flex items-center">
        <div className="max-w-md mx-auto w-full px-4 py-16">
          <div className="label-tag text-[color:var(--cc-yellow)] flex items-center gap-2"><LockKey size={14} weight="bold" /> Super admin</div>
          <h1 className="font-display font-black text-4xl sm:text-5xl tracking-tighter mt-3">Control room.</h1>
          <form onSubmit={submit} className="mt-8 space-y-4" data-testid="admin-login-form">
            <div>
              <label className="label-tag">Email</label>
              <input type="email" className="mt-2 w-full px-4 py-3 bg-white text-black border border-white outline-none" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} data-testid="admin-email" required />
            </div>
            <div>
              <label className="label-tag">Password</label>
              <input type="password" className="mt-2 w-full px-4 py-3 bg-white text-black border border-white outline-none" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} data-testid="admin-password" required />
            </div>
            {err && <div className="label-tag text-[color:var(--cc-yellow)]" data-testid="admin-login-error">{err}</div>}
            <button type="submit" disabled={loading} className="w-full bg-[color:var(--cc-yellow)] text-black label-tag px-6 py-4 disabled:opacity-60" data-testid="admin-login-submit">
              {loading ? "Signing in…" : "Enter admin panel"}
            </button>
          </form>
        </div>
      </section>
    </div>
  );
}
